export default __webpack_public_path__ + "static/media/Dashboard.a2db3b0a.svg";